import { randomHex, treeLeaves } from "../utils/MerkleTree";
import { StandardMerkleTree } from "@openzeppelin/merkle-tree";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../context";
import useProvider from "./useProvider";
import { ethers } from "ethers";
import CONTRACT_INFO from "../ContractInfo";
import { GMsV2 } from "../typechain-types/contracts/GMsV2";

const useClaimsAvailable = () => {
  const [numOfClaimsAvailable, setNumOfClaimsAvailable] = useState(0);
  const [claimProofs, setClaimProofs] = useState<(string | string[])[]>([]);
  const { wallet } = useContext(AppContext);
  const provider = useProvider();
  const contract = provider
    ? (new ethers.Contract(
        CONTRACT_INFO[window.chain].contract,
        CONTRACT_INFO[window.chain].abi,
        provider.getSigner()
      ) as GMsV2)
    : undefined;
  const checkClaims = async () => {
    if (wallet) {
      let claimsAvailable = 0;
      const proofs: (string | string[])[] = [];
      for (let index = 0; index < treeLeaves.length; index++) {
        const addresses = treeLeaves[index];
        const tree = StandardMerkleTree.of(addresses, ["address"]);
        let proof;
        try {
          proof = tree.getProof([wallet]);
          const hasUserClaimed = await contract?.hasUserClaimed(index);
          if (!hasUserClaimed) {
            claimsAvailable++;
          }
        } catch (e) {
          proof = randomHex;
        }
        proofs.push(proof);
      }
      setNumOfClaimsAvailable(claimsAvailable);
      setClaimProofs(proofs);
    }
  };
  useEffect(() => {
    checkClaims();
  }, [wallet]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    numOfClaimsAvailable,
    claimProofs,
  };
};

export default useClaimsAvailable;
